var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{staticClass:"warning-popup",style:({
    zIndex: _vm.zIndex,
    '--primary-color': _vm.primaryColor,
    '--background-color': _vm.backgroundColor,
    '--text-color': _vm.textColor,
    '--cta-color': _vm.ctaColor,
    '--button-text-color': _vm.buttonTextColor,
    '--title-weight': _vm.titleWeight,
    '--bottom': _vm.bottom + 'px',
  }),attrs:{"id":`${_vm.$options.name}-${_vm.instanceId}`,"data-module":"warning-popup","show-on-desk":_vm.showOnDesk,"show-on-mobile":_vm.showOnMobile}},[_c('div',{staticClass:"warning-popup__content"},[_c('div',{staticClass:"warning-popup__content__wrapper"},[_c('IconClose',{attrs:{"color":"#888888","title":"Fechar","size":"xs"}})],1),_c('div',{staticClass:"warning-popup__container"},[(_vm.title)?_c('h4',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.text)?_c('div',{staticClass:"warning-popup__container__text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),(_vm.linkLabel)?_c('EditorLink',{staticClass:"cta",attrs:{"model":_vm.linkUrl}},[_vm._v(" "+_vm._s(_vm.linkLabel)+" ")]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }